import React from 'react';

import { Table } from '../../../components/elements';

const BookingTransactions = ({ loading, transactionData, history }) => (
  <>
    <Table>
      <thead>
        <tr>
          <th>
            <div>
              <span>
                <a>
                  <i
                  // className={
                  //   placeNameSort === 'AES'
                  //     ? 'fas fa-sort-amount-down'
                  //     : 'fas fa-sort-amount-up'
                  // }
                  />
                </a>
                Place Name
              </span>
            </div>
          </th>
          <th>
            <div>
              <span>City</span>
            </div>
          </th>

          <th>
            <span>Payments</span>
          </th>
          <th>
            <span>C Fees</span>
          </th>
          <th>
            <span>Payout</span>
          </th>
          <th>
            <span>Bookings</span>
          </th>
          <th>
            <span>Guests</span>
          </th>
          <th>
            <span>Confirmed</span>
          </th>
          <th>
            <span>Cancelled</span>
          </th>
          <th>
            <span>Refunds</span>
          </th>
        </tr>
      </thead>

      <tbody>
        {transactionData.map(bad => (
          // console.log('');
          <tr key={bad.place_id}>
            <td
              style={{
                cursor: 'pointer',
                color: '#00AEEF',
                whiteSpace: 'nowrap',
              }}
            >
              <span
                onClick={() => {
                  const newTabUrl = `/table-booking-transaction/${bad.place_id}`;
                  history.push(newTabUrl);
                }}
              >
                {bad.place_name}
              </span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.city}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad.payment ? '-' : `$${parseFloat(bad.payment).toFixed(2)}`}
              </span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad.c_fees ? '-' : `$${parseFloat(bad.c_fees).toFixed(2)}`}
              </span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad.payout ? '-' : `$${parseFloat(bad.payout).toFixed(2)}`}
              </span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.total_bookings}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.total_guests}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.confirmed_count}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>{bad.cancelled_count}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
              <span>
                {!bad.refund_amount
                  ? '-'
                  : `-$${Math.abs(parseFloat(bad.refund_amount)).toFixed(2)}`}
              </span>
            </td>
          </tr>
        ))}
        <></>
      </tbody>
    </Table>
    {loading && (
      <span
        style={{
          padding: '1rem',
          color: '#00AEEF',
          fontSize: '18px',
        }}
      >
        Loading...
      </span>
    )}
  </>
);

export default BookingTransactions;
